import { useLocation } from 'react-router-dom'

export default function YourBusiness(prop: any) {
    const location = useLocation();

    return (<h1>Home</h1>)
}